import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../app/hooks";
import BetResultListItem from "../components/BetResultListItem";
import { getHistoryAsync } from "../historySlice";

export default function History() {
  const dispatch = useDispatch();

  var resolvedBets = useAppSelector((state) => state.history.betResults);

  useEffect(() => {
    dispatch(getHistoryAsync());
  }, []);

  return (
    <div>
      <h2>Recent Bets</h2>

      {resolvedBets.length > 0
        ? resolvedBets.map((betResult, index) => (
            <BetResultListItem result={betResult} key={index} />
          ))
        : "You have not placed any recent bets."}
    </div>
  );
}
